import { render } from "./AssignDisputeModal.vue?vue&type=template&id=980973ea&scoped=true"
import script from "./AssignDisputeModal.vue?vue&type=script&lang=js"
export * from "./AssignDisputeModal.vue?vue&type=script&lang=js"

import "./AssignDisputeModal.vue?vue&type=style&index=0&id=980973ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980973ea"]])

export default __exports__